import { render, staticRenderFns } from "./AppDetailsRoot.vue?vue&type=template&id=d09df5be"
import script from "./AppDetailsRoot.vue?vue&type=script&lang=ts"
export * from "./AppDetailsRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports